import { EntityBase } from "./EntityBase";
import { User } from "./User";
import { Contract } from "./Contract";
import { Company } from "./Company";
import { FuelType } from "./FuelType";
import { Utility } from "./Utility";
import { Account } from "./Account";
import { SellOffer } from "./SellOffer";
import { Bid } from "./Bid";
import { Pair } from "../obj/Pair";
import { RateClass } from "./RateClass";
import { LoadZone } from "./LoadZone";
import { State } from "./State";
import { BatchExport } from "./BatchExport";


export class KilowantContract extends Contract {
    sellerCompany: Company = null!;
    fuelType: FuelType = null!;
    utility: Utility = null!;
    rateClass: RateClass = null!;
    loadZone: LoadZone = null!;
    sellOffer: SellOffer = null!;
    buyOfferPrice: number = null!;
    sellOfferPrice: number = null!;
    fee: number = null!;
    bid: Bid = null!;
    cancelledByBuyer: boolean|null = null;
    cancelledBySeller: boolean|null = null;
    cancelledDate: Date|null = null;
    cancelledSellerUser: User = null!;
    cancelledSellerReason: string | null = null;
    termsName: string = null!;
    terms: string = null!;
    termsDocument: Pair = null!;
    termsHash: string = null!;
    disclosureStatement: string = null!;
    dateEntered: Date = null!;
    dateUpdated: Date = null!;
    termRescission: number = null!;
    canBeCancelledUntil: Date = null!;
    confirmed: boolean = null!;
    confirmedDate: Date = null!;
    confirmedSellerUser: User = null!;
    confirmDeadline: Date|null = null;
    confirmedByBuyer: boolean = null!;
    confirmedByBuyerDate: Date = null!;
    canBeCancelled: boolean = null!;
    detailsUtility: string = null!;
    detailsLoadZone: string = null!;
    detailsRateClass: string = null!;
    detailsAccountNumbers: string = null!;
    detailsProductType: string = null!;
    detailsBuyerFirstName: string = null!;
    detailsBuyerLastName: string = null!;
    detailsBuyerCompanyName: string = null!;
    detailsBuyerAddressLine1: string = null!;
    detailsBuyerAddressLine2: string = null!;
    detailsBuyerCity: string = null!;
    detailsBuyerZip: string = null!;
    detailsBuyerState: State = null!;
    detailsBuyerPhone: string = null!;
    detailsBuyerEmail: string = null!;
    detailsBuyerTaxExempt: boolean = false;
    detailsBuyerFederalTaxID: string = null!;
    detailsBuyerTaxExemptCertificateDocument: Pair = null!;
    detailsSellerFirstName: string = null!;
    detailsSellerLastName: string = null!;
    detailsSellerCompanyName: string = null!;
    detailsSellerAddressLine1: string = null!;
    detailsSellerAddressLine2: string = null!;
    detailsSellerCity: string = null!;
    detailsSellerZip: string = null!;
    detailsSellerState: State = null!;
    detailsSellerPhone: string = null!;
    detailsSellerEmail: string = null!;
    buyerSignedUserEmail: string | null = null;
    sellerSignedUserEmail: string | null = null;
    buyerSignedIP: string = null!;
    sellerSignedIP: string = null!;
    nextContractAutoAssigned: boolean = false;
    fromBuyOffer: boolean = false;
    confirmDeadlineLeftSeconds: number = null!;
    batchExport: BatchExport|null = null;
    signedByAI: number | null = null;

    getSalesPrice(): number {
       if (this.fee == null) {
          return this.price;
       }
       return Math.round((this.price + this.fee + Number.EPSILON) * 100000) / 100000;
    }

    priceForBuyer(): number {
       return this.getSalesPrice();
    }

    priceForSeller(): number {
       return this.price;
    }
}
